<template>
  <div>
    <BModal
      id="addTalent"
      ref="addTalent"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
      size="md"
      :centered="true"
      @hidden="talentSelected = []"
    >
      <div class="my-1">
        <div class="font-semibold text-center text-2xl text-black my-1">
          Tambah Talent
        </div>
        <BCol
          md="12"
          class="p-0"
        >
          <BFormGroup
            label-class="font-medium text-7 text-black"
            label="Partner"
          >
            <VSelect
              v-model="partnerName"
              label="name"
              disabled
            />
          </BFormGroup>
          <BFormGroup
            label-class="font-medium text-7 text-black"
            label="Talent"
          >
            <VSelect
              v-model="talentSelected"
              :options="listTalent"
              label="talent_name"
              multiple
              :selectable="talent => !talentExist.includes(talent.talent_id)"
            />
          </BFormGroup>
        </BCol>
        <div
          class="flex justify-center gap-20"
          style="gap: 20px"
        >
          <BButton
            size="md"
            variant="outline-primary"
            class="w-100"
            style="width: 160.5px"
            @click="$bvModal.hide('addTalent')"
          >
            Batal
          </BButton>
          <BButton
            size="md"
            variant="primary"
            class="w-100"
            block
            :disabled="loading"
            @click="addTalent()"
          >
            <BSpinner
              v-if="loading"
              variant="light"
              small
            />
            Tambahkan
          </BButton>
        </div>
      </div>
    </BModal>
    <ConfirmationMultipleInvoice
      :partner-name="partnerName"
      :periode="periode"
      :list-talent="publishedTalents"
      @confirm="confirmAddTalent"
    />
  </div>
</template>

<script>
import VSelect from 'vue-select'
import { komtimAxiosIns } from '@/libs/axios'
import ConfirmationMultipleInvoice from './ConfirmationMultipleInvoice.vue'

export default {
  components: {
    VSelect,
    ConfirmationMultipleInvoice,
  },
  props: {
    talentExist: {
      type: Array,
      default: () => [],
    },
    listTalent: {
      type: Array,
      default: () => [],
    },
    partnerId: {
      type: Number,
      default: 0,
    },
    partnerName: {
      type: String,
      default: '',
    },
    periode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      talentSelected: [],
      loading: false,
      publishedTalents: [],
    }
  },
  methods: {
    async addTalent() {
      try {
        this.loading = true
        const { data: { data } } = await komtimAxiosIns.get('v1/invoices/check_talents', {
          params: {
            partner_id: this.partnerId,
            invoice_period: this.periode,
          },
        })
        const selectedIds = new Set(this.talentSelected.map(t => t.user_id))
        this.publishedTalents = data.talents.filter(talent => selectedIds.has(talent.user_id))
        if (!this.publishedTalents.length) {
          this.$bvModal.hide('addTalent')
          this.$emit('update', this.talentSelected)
          return
        }
        this.$bvModal.show('confirmationMultipleInvoice')
      } catch (error) {
        this.$toast_error({ message: 'Gagal memperoleh data talent dengan invoice terpublish' })
      } finally {
        this.loading = false
      }
    },
    confirmAddTalent() {
      this.$bvModal.hide('addTalent')
      this.$emit('update', this.talentSelected)
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/vue/libs/vue-flatpicker.scss';
</style>
